import React, { Component } from 'react';
import { Button, Col, DatePicker, Form, Input, Row, Select } from 'antd';
import { connect } from 'react-redux';

const FormItem = Form.Item;
const { Option } = Select;

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contract_type: [],
    };
  }

  componentDidMount() {}

  componentWillReceiveProps(nextProps) {
    if (this.props.contract_type !== nextProps.contract_type) {
      this.setState({
        contract_type: nextProps.contract_type,
      });
    }
  }

  /**
   * 合同搜索
   */
  search = e => {
    e.preventDefault();
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  reset = e => {
    e.preventDefault();
    this.props.form.setFieldsValue({
      no: undefined,
      status: undefined,
      type: undefined,
      maturity: undefined,
    });
    const data = this.props.form.getFieldsValue();
    this.props.search(data);
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { contract_type: contractType } = this.state;
    const formItemLayout = {
      labelCol: { span: 8 },
      wrapperCol: { span: 16 },
    };
    return (
      <Form className="search-form" onSubmit={this.search}>
        <Row justify="space-between" type="flex">
          <Col span={5}>
            <FormItem>
              {getFieldDecorator('no')(<Input placeholder="合同编号/所属人姓名" />)}
            </FormItem>
          </Col>
          <Col span={6}>
            <FormItem label="过期时间" {...formItemLayout}>
              {getFieldDecorator('maturity')(
                <DatePicker placeholder="到期时间" style={{ width: '100%' }} />,
              )}
            </FormItem>
          </Col>
          <Col span={5}>
            <FormItem label="合同类型" {...formItemLayout}>
              {getFieldDecorator('type')(
                <Select placeholder="合同类型">
                  <Option key="-1">所有类型</Option>
                  {contractType.map((item, index) => {
                    return <Option key={item.value}>{item.key}</Option>;
                  })}
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem label="状态" {...formItemLayout}>
              {getFieldDecorator('status')(
                <Select placeholder="状态">
                  <Option value="-1">全部</Option>
                  <Option value="0">未使用</Option>
                  <Option value="1">已使用</Option>
                  <Option value="2">遗失</Option>
                  <Option value="3">作废</Option>
                  <Option value="4">已分配</Option>
                  <Option value="5">待审核</Option>
                  <Option value="6">转移中</Option>
                </Select>,
              )}
            </FormItem>
          </Col>
          <Col span={4}>
            <FormItem>
              <Row type="flex" justify="end">
                <Button type="primary" htmlType="submit" style={{ marginRight: '10px' }}>
                  搜索
                </Button>
                <Button onClick={this.reset} style={{ marginRight: '10px' }}>
                  重置
                </Button>
              </Row>
            </FormItem>
          </Col>
        </Row>
      </Form>
    );
  }
}

export default connect(state => state)(Form.create()(Index));



// WEBPACK FOOTER //
// ./src/components/xianxing/contract/FormSearch.js